module.exports = __webpack_public_path__ + "static/media/whitney.fc51a6c2.png";